import React, { Component } from "react";
import ReactDOM from 'react-dom';
import DayPicker from 'react-day-picker';

import Variables from "../Utils/Variables";
import Helpers from "../Utils/Helpers";


export default class TYDatePicker extends Component{
    constructor(props){
        super(props);

        this.state = {
            selectedDate: this.props.selectedDate,
            calendarShown: false
        };

        this.calendarRef = null;
    }

    componentWillMount() {
        document.addEventListener('click', this.handleDocClick, false);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocClick, false);
    }

    componentWillUpdate(nextProps){
        if(nextProps.selectedDate && nextProps.selectedDate !== this.state.selectedDate)
            this.setState({selectedDate: nextProps.selectedDate});
    }

    handleDocClick = e => {
        if(!ReactDOM.findDOMNode(this).contains(e.target)) {
            if(this.state.calendarShown)
                this.setState({calendarShown: false});
        }
    };

    toggleCalendar = () => {
        this.setState({calendarShown: !this.state.calendarShown});
    };

    datePicked = date => {
        this.setState({selectedDate: date}, () => {
            this.toggleCalendar();
            this.props.onDatePicked(date);
        });
    };

    render(){
        const {disabled, right, placeholder, className, inputClassName} = this.props;

        return (
            <div className={`relative ty-calandar ${className} ${disabled && 'disabled'}`}>
                <div className={`ty-input-div blue_dark pointer ${inputClassName}`} ref="input" onClick={!disabled && this.toggleCalendar}>
                    {
                        this.state.selectedDate ?
                            Helpers.formatDate(this.state.selectedDate, "DD/MM/YY")
                            :
                            <div className="center gray_dark">{placeholder}</div>
                    }
                </div>
                {
                    this.state.calendarShown ?
                        <div ref={ref => {this.calendarRef = ref;}} className={`ty-calendar absolute top-40 bg-white ${right && " right-0"}`}>
                            <DayPicker
                                onDayClick={this.datePicked}
                                selectedDays={this.state.selectedDate}
                                locale="fr"
                                months={Variables.months}
                                weekdaysLong={Variables.weekdays_long}
                                weekdaysShort={Variables.weekdays_short}
                                firstDayOfWeek={1}
                            />
                        </div>
                        : null
                }
            </div>
        );
    }
}

TYDatePicker.defaultProps = {
    disabled: false,
    selectedDate: null,
    onDatePicked: day => {},
    placeholder: "01/01/2018",
    className: "",
    inputClassName: "",
    right: false
};



// WEBPACK FOOTER //
// ./src/components/TYDatePicker.js